import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import styles from './LegalScreen.module.css';

const CONTACT_EMAIL = 'bolaosupport@gmail.com';

export default function PrivacyScreen() {
  const { t } = useTranslation();

  return (
    <main className="screen">
      <Link to="/" className="muted">
        {t('common.back')}
      </Link>

      <div>
        <h1>{t('privacy.title')}</h1>
        <p className="muted" style={{ fontSize: '0.8rem' }}>
          {t('privacy.updated')}
        </p>
      </div>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.introTitle')}</h2>
        <p className={styles.body}>{t('privacy.introBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.collectTitle')}</h2>
        <ul className={styles.list}>
          <li>{t('privacy.collectAccount')}</li>
          <li>{t('privacy.collectPlay')}</li>
          <li>{t('privacy.collectPreference')}</li>
          <li>{t('privacy.collectAnalytics')}</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.shareTitle')}</h2>
        <p className={styles.body}>{t('privacy.shareBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.retentionTitle')}</h2>
        <p className={styles.body}>{t('privacy.retentionBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.childrenTitle')}</h2>
        <p className={styles.body}>{t('privacy.childrenBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.changesTitle')}</h2>
        <p className={styles.body}>{t('privacy.changesBody')}</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{t('privacy.contactTitle')}</h2>
        <p className={styles.body}>{t('privacy.contactBody', { email: CONTACT_EMAIL })}</p>
      </section>
    </main>
  );
}
